import * as React from 'react';
import { CoreInput } from '../internal/WixUiCoreComponents/components/CoreInput';
import { st, classes } from './Input.st.css';
import { ErrorMessageWrapper } from '../ErrorMessageWrapper';
import { InputProps } from './types';

export const Input: React.FunctionComponent<InputProps> = (
  props: InputProps,
) => {
  const { errorMessage, error, className, ...coreInputProps } = props;
  const { disabled } = props;

  return (
    <ErrorMessageWrapper
      error={error}
      errorMessage={errorMessage}
      disabled={disabled}
      render={(errorProps) => (
        <CoreInput
          className={st(classes.root, { error }, className)}
          error={errorProps.error}
          {...coreInputProps}
        />
      )}
    />
  );
};
